import React, { Suspense, lazy } from "react";
import {
    useRoutes,
} from "react-router-dom";

import { AuthorisedRoute } from "../middlewares/auth.middleware";

import Loader from "components/Loader";
// Landing stays eager — it's the most common entry point, and the checklist
// requires the page shell to render without waiting on a chunk fetch.
import Landing from "views/Landing";

import "../styles/app.global.scss";
import "../assets/styles/css/App.css";
import { authRouteConstants } from "constants/routeConstants";

const ProductList = lazy(() => import("views/ProductList"));
const ProductView = lazy(() => import("views/ProductView"));
const Cart = lazy(() => import("views/Cart"));
const Checkout = lazy(() => import("views/Checkout"));
const OrderComplete = lazy(() => import("views/OrderComplete"));
const OrderHistory = lazy(() => import("views/OrderHistory"));
const UserSetting = lazy(() => import("views/UserSetting"));
const About = lazy(() => import("views/About"));
const ContactUs = lazy(() => import("views/ContactUs"));
const FAQs = lazy(() => import("views/FAQs"));
const Logout = lazy(() => import("containers/Logout"));
const Payment = lazy(() => import("containers/Payment"));
const CallbackPage = lazy(() => import("containers/AuthDialog/Callback"));
const SilentRenew = lazy(() => import("containers/AuthDialog/SilentRenew"));
const Payments = lazy(() => import("views/Payments"));

const RouteFallback = () => <Loader open />;

// eslint-disable-next-line
export default () => {
    let element = useRoutes([
        {
            path: "/",
            element: <Landing />,
        },
        {
            name: "Products",
            path: "/products",
            element: (
                <ProductList
                    breadcrumbs={[
                        {
                            path: "/",
                            name: "Home",
                        },
                    ]}
                />
            ),
        },
        {
            name: "Product",
            path: "/product/:productId",
            element: (
                <ProductView
                    breadcrumbs={[
                        {
                            path: "/",
                            name: "Home",
                        },
                        {
                            path: "/products",
                            name: "Products",
                        },
                    ]}
                />
            ),
        },
        {
            name: "Cart",
            path: "/cart",
            element: (
                <Cart
                    breadcrumbs={[
                        {
                            path: "/",
                            name: "Home",
                        },
                    ]}
                />
            ),
        },
        {
            name: "Checkout",
            path: "/checkout",
            element: (
                <AuthorisedRoute>
                <Checkout
                    breadcrumbs={[
                        {
                            path: "/",
                            name: "Home",
                        },
                    ]}
                />
                </AuthorisedRoute>
            ),
        },
        {
            name: "Payment",
            path: "/payment",
            element: (
                <AuthorisedRoute>
                <Payments/>
                </AuthorisedRoute>
            ),
        },
        {
            name: "Order Successful",
            path: "/order-status",
            element: (
                <AuthorisedRoute>
                <OrderComplete
                    breadcrumbs={[
                        {
                            path: "/",
                            name: "Home",
                        },
                    ]}
                />
                </AuthorisedRoute>
            ),
        },
        {
            name: "Order History",
            path: "/order-history",
            element: (
                <AuthorisedRoute>
                <OrderHistory
                    breadcrumbs={[
                        {
                            path: "/",
                            name: "Home",
                        },
                    ]}
                />
                </AuthorisedRoute>
            ),
        },
        {
            name: "User Settings",
            path: "/user-setting",
            element: (
                <AuthorisedRoute>
                <UserSetting
                    breadcrumbs={[
                        {
                            path: "/",
                            name: "Home",
                        },
                    ]}
                />
                </AuthorisedRoute>
            ),
        },
        {
            name: "About",
            path: "/about",
            element: (
                <About
                    breadcrumbs={[
                        {
                            path: "/",
                            name: "Home",
                        },
                    ]}
                />
            ),
        },
        {
            name: "Contact Us",
            path: "/contact",
            element: (
                <ContactUs
                    breadcrumbs={[
                        {
                            path: "/",
                            name: "Home",
                        },
                    ]}
                />
            ),
        },
        {
            name: "FAQs",
            path: "/faqs",
            element: (
                <FAQs
                    breadcrumbs={[
                        {
                            path: "/",
                            name: "Home",
                        },
                    ]}
                />
            ),
        },
        {
            path: authRouteConstants.LOGOUT,
            element: <Logout />
        },
        {
            path: authRouteConstants.LOGINCALLBACK,
            element: <CallbackPage />
        },
        {
            path: authRouteConstants.SILENTRENEW,
            element: <SilentRenew />
        },
        {
            path: "/payment/:payment_id/:orderId",
            element: <Payment />
        }
    ]);
    return <Suspense fallback={<RouteFallback />}>{element}</Suspense>;
};
